import { api } from './api'

export const authService = {
  validateToken: async (token: string) => {
    // Save token to localStorage temporarily so interceptor can use it
    const currentToken = localStorage.getItem('authToken')
    localStorage.setItem('authToken', token)
    
    try {
      const response = await api.get('/user')
      return response.data
    } finally {
      // Restore original token if different
      if (currentToken !== token) {
        if (currentToken) {
          localStorage.setItem('authToken', currentToken)
        } else {
          localStorage.removeItem('authToken')
        }
      }
    }
  },
  
  signin: async (email: string, password: string) => {
    const response = await api.post('/authenticate', {
      user: { email, password }
    })
    return response
  },
  
  logout: async () => {
    const response = await api.delete('/logout')
    return response.data
  }
}